import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Toggle} from '../../../../../libs/shared/ui/src/components/booleanInputs/toggle';
import {TextAreaBox} from '../../../../../libs/shared/ui/src/components/boxedInputs/textAreaBox';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {ChannelFrontChatModel} from '../../../../models/api/channelModel';
import {SettingsFieldLine} from '../../../common/settingsFieldLine';
import {SettingsCommonChannelFieldProps} from '../settingsCommonChannelFields';

/*
 * Props.
 */

interface SettingsWelcomeMessageFieldProps extends SettingsCommonChannelFieldProps<ChannelFrontChatModel> {}

/*
 * Style.
 */

const StyledInlineBlock = styled.div`
  display: inline-block;
`;

const StyledTextAreaBox = styled(TextAreaBox)`
  min-width: 230px;
  max-width: 600px;
`;

/*
 * Component.
 */

export const SettingsWelcomeMessageField: FC<SettingsWelcomeMessageFieldProps> = (props) => (
  <>
    <SettingsFieldLine
      title={<Trans id="settingschannel-welcomemessage-title">Welcome message</Trans>}
      subtitle={
        <Trans id="settingschannel-welcomemessage-subtitle">
          Visitors will see this message after landing on the chat widget
        </Trans>
      }
      content={
        <Toggle
          isChecked={props.edited.preferences.widgetPushMessage.enabled}
          onChange={(v) => {
            props.onPreferencesChange({
              widgetPushMessage: {
                ...props.edited.preferences.widgetPushMessage,
                enabled: v,
              },
            });
          }}
        />
      }
    />
    {props.edited.preferences.widgetPushMessage.enabled && (
      <StyledInlineBlock>
        <StyledTextAreaBox
          size={VisualSizesEnum.SMALL}
          label={<Trans id="settingschannel-welcomemessage-textlabel">Welcome message</Trans>}
          value={props.edited.preferences.widgetPushMessage.message}
          isRequired
          onChange={(v) => {
            props.onPreferencesChange({
              widgetPushMessage: {
                ...props.edited.preferences.widgetPushMessage,
                message: v,
              },
            });
          }}
          shouldAllowResize
        />
      </StyledInlineBlock>
    )}
  </>
);
